import { Navigate, useLocation, useParams } from "react-router-dom";

export function LegacyEventRedirect({ section, tab }: { section: string; tab: string }) {
  const { id } = useParams();
  const { search, hash } = useLocation();
  const params = new URLSearchParams(search);
  params.set("aba", tab);
  return <Navigate replace to={`/evento/${id}/${section}?${params.toString()}${hash}`} />;
}